export { Tabla2abmModule } from './tabla2abm.module';
export { Tabla2abm } from './tabla2abm.component';
export { collapsibleTabla2abm } from './collapsible.animation';
export * from './interfaces';
